import React from 'react'
import './TransitionAgencyHeroSection.component.scss'

const TransitionAgencyHeroSection = () => (
  <section className='tya-hero-section'>
    <div className='tya-hero-section__inner'>
      <h1 className='tya-hero-section__heading'>Planning Your Agency&rsquo;s Next Chapter</h1>
    </div>
  </section>
)

export default TransitionAgencyHeroSection
